<div *ngIf="plans.length>0" class="table-responsive card p-3">
    <h3 class="mb-3">Precios de Pruebas Psicométricas y Créditos</h3>
    <table class="table">
        <thead>
            <tr>
                <th>#</th>
                <th>Plan</th>
                <th>Precio ARS</th>
                <th>Precio USD</th>
                <th>Precio MXN</th>
                <th>Precio EUR</th>
                <th>Créditos</th>
                <th>Actualizar</th>
                
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>1</td>
                <td>Starter</td>
                <td><input type="number" [(ngModel)]="plans[0].price"></td>
                <td><input type="number" [(ngModel)]="plans[0].usd"></td>
                <td><input type="number" [(ngModel)]="plans[0].mxn"></td>
                <td><input type="number" [(ngModel)]="plans[0].eur"></td>
                <td><input type="number" [(ngModel)]="plans[0].tests"></td>
                <td><button class="btn btn-sm btn-success btn-rounded waves-effect" (click)="updatePlan(plans[0])" >Actualizar</button></td>
            </tr>
            <tr>
                <td>2</td>
                <td>Professional</td>
                <td><input type="number" [(ngModel)]="plans[1].price"></td>
                <td><input type="number" [(ngModel)]="plans[1].usd"></td>
                <td><input type="number" [(ngModel)]="plans[1].mxn"></td>
                <td><input type="number" [(ngModel)]="plans[1].eur"></td>
                <td><input type="number" [(ngModel)]="plans[1].tests"></td>
                <td><button class="btn btn-sm btn-success btn-rounded waves-effect" (click)="updatePlan(plans[1])" >Actualizar</button></td>

            </tr>
            <tr>
                <td>3</td>
                <td>Premium</td>
                <td><input type="number" [(ngModel)]="plans[2].price"></td>
                <td><input type="number" [(ngModel)]="plans[2].usd"></td>
                <td><input type="number" [(ngModel)]="plans[2].mxn"></td>
                <td><input type="number" [(ngModel)]="plans[2].eur"></td>
                <td><input type="number" [(ngModel)]="plans[2].tests"></td>
                <td><button class="btn btn-sm btn-success btn-rounded waves-effect" (click)="updatePlan(plans[2])" >Actualizar</button></td>

            </tr>
            <tr>
                <td>4</td>
                <td>Vip</td>
                <td><input type="number" [(ngModel)]="plans[3].price"></td>
                <td><input type="number" [(ngModel)]="plans[3].usd"></td>
                <td><input type="number" [(ngModel)]="plans[3].mxn"></td>
                <td><input type="number" [(ngModel)]="plans[3].eur"></td>
                <td><input type="number" [(ngModel)]="plans[3].tests"></td>
                <td><button class="btn btn-sm btn-success btn-rounded waves-effect" (click)="updatePlan(plans[3])" >Actualizar</button></td>

            </tr>

            <tr>
              <td>5</td>
              <td>White Label</td>
              <td><input type="number" [(ngModel)]="plans[4].price"></td>
              <td><input type="number" [(ngModel)]="plans[4].usd"></td>
              <td><input type="number" [(ngModel)]="plans[4].mxn"></td>
              <td><input type="number" [(ngModel)]="plans[4].eur"></td>
              <td><input type="number" [(ngModel)]="plans[4].tests"></td>
              <td><button class="btn btn-sm btn-success btn-rounded waves-effect" (click)="updatePlan(plans[4])" >Actualizar</button></td>

          </tr>

        </tbody>
    </table>
</div>


<div *ngIf="plans.length>0" class="table-responsive card p-3">
    <h3 class="mb-3">Precios de Suscripciones</h3>
    <table class="table">
        <thead>
            <tr>
                <th>#</th>
                <th>Plan</th>
                <th>Precio ARS</th>
                <th>Precio USD</th>
                <th>Precio MXN</th>
                <th>Precio EUR</th>
                <th>Ahorro ARS</th>
                <th>Ahorro USD</th>
                <th>Ahorro MXN</th>
                <th>Ahorro EUR</th>
                <th>Actualizar</th>
                
            </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>Evaluaciones (Mensual)</td>
            <td><input type="number" [(ngModel)]="plans[5].price"></td>
            <td><input type="number" [(ngModel)]="plans[5].usd"></td>
            <td><input type="number" [(ngModel)]="plans[5].mxn"></td>
            <td><input type="number" [(ngModel)]="plans[5].eur"></td>
            <td></td>
            <td></td>
            <td></td>

            <td><button class="btn btn-sm btn-success btn-rounded waves-effect" (click)="updatePlan(plans[5])" >Actualizar</button></td>

        </tr>

        <tr>
            <td>2</td>
            <td>Evaluaciones + Creador (Mensual)</td>
            <td><input type="number" [(ngModel)]="plans[6].price"></td>
            <td><input type="number" [(ngModel)]="plans[6].usd"></td>
            <td><input type="number" [(ngModel)]="plans[6].mxn"></td>
            <td><input type="number" [(ngModel)]="plans[6].eur"></td>
            <td></td>
            <td></td>
            <td></td>
            <td><button class="btn btn-sm btn-success btn-rounded waves-effect" (click)="updatePlan(plans[6])" >Actualizar</button></td>

        </tr>

        <tr>
            <td>3</td>
            <td>Evaluaciones (Anual)</td>
            <td><input type="number" [(ngModel)]="plans[7].price"></td>
            <td><input type="number" [(ngModel)]="plans[7].usd"></td>
            <td><input type="number" [(ngModel)]="plans[7].mxn"></td>
            <td><input type="number" [(ngModel)]="plans[7].eur"></td>
            <td><input type="number" [(ngModel)]="plans[7].saveArs"></td>
            <td><input type="number" [(ngModel)]="plans[7].saveUsd"></td>
            <td><input type="number" [(ngModel)]="plans[7].saveMxn"></td>
            <td><input type="number" [(ngModel)]="plans[7].saveEur"></td>
            <td><button class="btn btn-sm btn-success btn-rounded waves-effect" (click)="updatePlan(plans[7])" >Actualizar</button></td>
        </tr>

        <tr>
            <td>4</td>
            <td>Evaluaciones + Creador(Anual)</td>
            <td><input type="number" [(ngModel)]="plans[8].price"></td>
            <td><input type="number" [(ngModel)]="plans[8].usd"></td>
            <td><input type="number" [(ngModel)]="plans[8].mxn"></td>
            <td><input type="number" [(ngModel)]="plans[8].eur"></td>
            <td><input type="number" [(ngModel)]="plans[8].saveArs"></td>
            <td><input type="number" [(ngModel)]="plans[8].saveUsd"></td>
            <td><input type="number" [(ngModel)]="plans[8].saveMxn"></td>
            <td><input type="number" [(ngModel)]="plans[8].saveEur"></td>
            <td><button class="btn btn-sm btn-success btn-rounded waves-effect" (click)="updatePlan(plans[8])" >Actualizar</button></td>
        </tr>

        </tbody>
    </table>
</div>